
class FrontendNotificationsAPI {
  constructor() {
    this.baseURL = process.env.REACT_APP_API_BASE_URL;
  }

  debugLog(method, url, data = null, response = null) {
  }

  getAuthHeaders() {
    const user = this.getCurrentUser();
    const headers = {
      'Content-Type': 'application/json'
    };

    if (user && user.id) {
      headers['Authorization'] = `Bearer ${user.id}`;
      headers['X-Client-User-ID'] = user.id.toString();
    }

    const csrfToken = this.getCSRFToken();
    if (csrfToken && !csrfToken.includes('{{')) {
      headers['X-CSRF-Token'] = csrfToken;
    }


    return headers;
  }

  getCSRFToken() {
    const metaTag = document.querySelector('meta[name="csrf-token"]');
    if (metaTag) {
      return metaTag.getAttribute('content');
    }
    
    const cookieValue = document.cookie
      .split('; ')
      .find(row => row.startsWith('_csrf='));
    
    return cookieValue ? cookieValue.split('=')[1] : '';
  }

  getRequestConfig(method = 'GET', body = null) {
    const config = {
      method,
      credentials: 'include',
      headers: this.getAuthHeaders()
    };

    if (body) {
      config.body = JSON.stringify(body);
    }

    return config;
  }

  getCurrentUser() {
    try {
      const userData = localStorage.getItem('loggedInUser');
      
      if (userData && userData !== 'undefined' && userData !== 'null') {
        const parsed = JSON.parse(userData);
        
        if (parsed && parsed.id) {
          return parsed;
        }
      }
      
      return null;
    } catch (error) {
      console.error('❌ Error parsing client_user data from localStorage:', error);
      return null;
    }
  }

  isAuthenticated() {
    return !!this.getCurrentUser();
  }

  async handleResponse(response) {
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      const text = await response.text();
      throw new Error(`Backend nem elérhető (${response.status}). Ellenőrizd, hogy a backend fut és be vagy jelentkezve.`);
    }

    return response.json();
  }

  async handleFetchError(error, endpoint) {
     if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) {
      const corsMessage = 'CORS hiba: A backend nem engedélyezi az Authorization header-t.\n' +
                         'Backend fejlesztő: Adja hozzá az "authorization" header-t az Access-Control-Allow-Headers-hez.\n' +
                         'Addig az értesítések nem működnek.';
      throw new Error(corsMessage);
    }
    
    throw error;
  }



  async getNotifications(filters = {}) {
    const endpoint = '/notifications';
    try {
      if (!this.isAuthenticated()) {
        throw new Error('Nem vagy bejelentkezve. Jelentkezz be az értesítések megtekintéséhez.');
      }

      const user = this.getCurrentUser();
      if (!user || !user.id) {
        throw new Error('Nem vagy bejelentkezve. Jelentkezz be az értesítések megtekintéséhez.');
      }

      const enhancedFilters = {
        ...filters,
        client_user_id: user.id
      };
      
      const params = new URLSearchParams();
      
      Object.keys(enhancedFilters).forEach(key => {
        if (enhancedFilters[key] !== undefined && enhancedFilters[key] !== null) {
          params.append(key, enhancedFilters[key]);
        }
      });

      const url = `${endpoint}${params.toString() ? '?' + params.toString() : ''}`;

      const response = await fetch(this.baseURL + url, this.getRequestConfig());
      
      const data = await this.handleResponse(response);
      this.debugLog('GET', url, enhancedFilters, data);

      if (!data.success) {
        throw new Error(data.error || 'API response indicates failure');
      }

      return data.data;
    } catch (error) {
      await this.handleFetchError(error, endpoint);
    }
  }

  async getStats() {
    const endpoint = '/notifications/stats';
    try {
      if (!this.isAuthenticated()) {
        throw new Error('Nem vagy bejelentkezve. Jelentkezz be az értesítési statisztikák megtekintéséhez.');
      }

      const user = this.getCurrentUser();
      if (!user || !user.id) {
        throw new Error('Nem vagy bejelentkezve. Jelentkezz be az értesítési statisztikák megtekintéséhez.');
      }

      const url = `${endpoint}?client_user_id=${user.id}`;

      const response = await fetch(this.baseURL + url, this.getRequestConfig());
      
      const data = await this.handleResponse(response);
      this.debugLog('GET', url, { client_user_id: user.id }, data);

      if (!data.success) {
        throw new Error(data.error || 'API response indicates failure');
      }

      return data.data;
    } catch (error) {
      await this.handleFetchError(error, endpoint);
    }
  }

  async markAsRead(id) {
    try {
      if (!this.isAuthenticated()) {
        throw new Error('Nem vagy bejelentkezve. Jelentkezz be az értesítés olvasottnak jelöléséhez.');
      }

      const user = this.getCurrentUser();
      if (!user || !user.id) {
        throw new Error('Nem vagy bejelentkezve. Jelentkezz be az értesítés olvasottnak jelöléséhez.');
      }

      const requestBody = {
        id: id,
        client_user_id: user.id
      };

      const response = await fetch(
        `${this.baseURL}/notifications/${id}/read`, 
        this.getRequestConfig('POST', requestBody)
      );
      const data = await this.handleResponse(response);
      
      this.debugLog('POST', `/notifications/${id}/read`, requestBody, data);

      if (!data.success) {
        throw new Error(data.error || 'Failed to mark notification as read');
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  async markAllAsRead() {
    try {
      if (!this.isAuthenticated()) {
        throw new Error('Nem vagy bejelentkezve. Jelentkezz be az értesítések olvasottnak jelöléséhez.');
      }

      const user = this.getCurrentUser();
      if (!user || !user.id) {
        throw new Error('Nem vagy bejelentkezve. Jelentkezz be az értesítések olvasottnak jelöléséhez.');
      }

      const requestBody = {
        client_user_id: user.id
      };

      const response = await fetch(
        `${this.baseURL}/notifications/mark-all-read`, 
        this.getRequestConfig('POST', requestBody)
      );
      const data = await this.handleResponse(response);
      
      this.debugLog('POST', '/notifications/mark-all-read', requestBody, data);

      if (!data.success) {
        throw new Error(data.error || 'Failed to mark all notifications as read');
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  async deleteNotification(id) {
    try {
      const user = this.getCurrentUser();
      if (!user || !user.id) {
        throw new Error('Nem vagy bejelentkezve. Jelentkezz be az értesítés törléséhez.');
      }

      const requestData = {
        id,
        client_user_id: user.id
      };

      const response = await fetch(
        `${this.baseURL}/notifications/${id}`,
        this.getRequestConfig('POST', requestData)
      );
      const data = await this.handleResponse(response);

      this.debugLog('POST', `/notifications/${id}`, requestData, data);

      if (!data.success) {
        throw new Error(data.error || 'Failed to delete notification');
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  async getPreferences() {
    const endpoint = '/notification-preferences';
    try {
      const user = this.getCurrentUser();
      if (!user || !user.id) {
        throw new Error('Nem vagy bejelentkezve. Jelentkezz be a beállítások megtekintéséhez.');
      }

      const url = `${endpoint}?client_user_id=${user.id}`;

      const response = await fetch(
        `${this.baseURL}${url}`,
        this.getRequestConfig()
      );
      
      if (response.status === 404) {
        return this.getDefaultPreferences();
      }
      
      const data = await this.handleResponse(response);

      this.debugLog('GET', url, { client_user_id: user.id }, data);

      if (!data.success) {
        throw new Error(data.error || 'Failed to get preferences');
      }

      return data.data;
    } catch (error) {
      if (error.message.includes('404')) {
        return this.getDefaultPreferences();
      }
      await this.handleFetchError(error, endpoint);
    }
  }

  getDefaultPreferences() {
    return {
      // Járműkezelés értesítések
      vehicle_added_to_company_daily_email: false,
      vehicle_added_to_company_instant_email: false,
      vehicle_added_to_company_system: true,

      vehicle_assigned_to_user_daily_email: false,
      vehicle_assigned_to_user_instant_email: true,
      vehicle_assigned_to_user_system: true,

      vehicle_unassigned_from_user_daily_email: false,
      vehicle_unassigned_from_user_instant_email: true,
      vehicle_unassigned_from_user_system: true,

      vehicle_status_changed_daily_email: false,
      vehicle_status_changed_instant_email: false,
      vehicle_status_changed_system: true,

      vehicle_document_uploaded_daily_email: false,
      vehicle_document_uploaded_instant_email: false,
      vehicle_document_uploaded_system: true,

      vehicle_document_expiring_daily_email: true,
      vehicle_document_expiring_instant_email: false,
      vehicle_document_expiring_system: true,

      vehicle_service_due_daily_email: true,
      vehicle_service_due_instant_email: false,
      vehicle_service_due_system: true,

      vehicle_rental_starting_soon_daily_email: false,
      vehicle_rental_starting_soon_instant_email: true,
      vehicle_rental_starting_soon_system: true,

      vehicle_rental_ending_soon_daily_email: false,
      vehicle_rental_ending_soon_instant_email: true,
      vehicle_rental_ending_soon_system: true,

      // Email/Levelezés értesítések
      new_email_daily_email: false,
      new_email_instant_email: false,
      new_email_system: true,

      // Chat értesítések
      chat_message_daily_email: false,
      chat_message_instant_email: false,
      chat_message_system: true,

      // Reklamáció értesítések
      complaint_created_daily_email: false,
      complaint_created_instant_email: false,
      complaint_created_system: true,

      complaint_updated_daily_email: false,
      complaint_updated_instant_email: true,
      complaint_updated_system: true,

      complaint_response_daily_email: false,
      complaint_response_instant_email: true,
      complaint_response_system: true,

      complaint_resolved_daily_email: false,
      complaint_resolved_instant_email: true,
      complaint_resolved_system: true,

      // Ticket/Hibabejelentés értesítések
      ticket_created_daily_email: false,
      ticket_created_instant_email: false,
      ticket_created_system: true,

      ticket_response_daily_email: false,
      ticket_response_instant_email: true,
      ticket_response_system: true,

      ticket_status_changed_daily_email: false,
      ticket_status_changed_instant_email: false,
      ticket_status_changed_system: true,

      ticket_resolved_daily_email: false,
      ticket_resolved_instant_email: true,
      ticket_resolved_system: true,

      // Naptár értesítések
      calendar_event_daily_email: true,
      calendar_event_instant_email: false,
      calendar_event_system: true,

      // Dokumentum értesítések
      document_notification_daily_email: false,
      document_notification_instant_email: false,
      document_notification_system: true,

      // Rendszer értesítések
      system_notification_daily_email: false,
      system_notification_instant_email: false,
      system_notification_system: true
    };
  }

  async updatePreferences(preferences) {
    try {
      const user = this.getCurrentUser();
      if (!user || !user.id) {
        throw new Error('Nem vagy bejelentkezve. Jelentkezz be a beállítások módosításához.');
      }
      
      const requestData = {
        ...preferences,
        client_user_id: user.id
      };
      
      const response = await fetch(
        `${this.baseURL}/notification-preferences/update`, 
        this.getRequestConfig('POST', requestData)
      );

      if (response.status === 404) {
        return { success: true, message: 'Beállítások mentve (helyi mentés, backend még fejlesztés alatt)' };
      }

      const data = await this.handleResponse(response);
      
      this.debugLog('POST', '/notification-preferences/update', requestData, data);

      if (!data.success) {
        throw new Error(data.error || 'Failed to update preferences');
      }

      return data;
    } catch (error) {
      if (error.message.includes('404')) {
        return { success: true, message: 'Beállítások mentve (helyi mentés, backend még fejlesztés alatt)' };
      }
      throw error;
    }
  }

  async resetPreferences() {
    try {
      const user = this.getCurrentUser();
      if (!user || !user.id) {
        throw new Error('Nem vagy bejelentkezve. Jelentkezz be a beállítások alaphelyzetbe állításához.');
      }
      
      const requestData = {
        client_user_id: user.id
      };
      
      const response = await fetch(
        `${this.baseURL}/notification-preferences/reset`, 
        this.getRequestConfig('POST', requestData)
      );

      if (response.status === 404) {
        return { success: true, message: 'Beállítások alaphelyzetbe állítva (helyi mentés, backend még fejlesztés alatt)' };
      }

      const data = await this.handleResponse(response);
      
      this.debugLog('POST', '/notification-preferences/reset', requestData, data);

      if (!data.success) {
        throw new Error(data.error || 'Failed to reset preferences');
      }

      return data;
    } catch (error) {
      if (error.message.includes('404')) {
        return { success: true, message: 'Beállítások alaphelyzetbe állítva (helyi mentés, backend még fejlesztés alatt)' };
      }
      throw error;
    }
  }
}

const frontendNotificationsAPI = new FrontendNotificationsAPI();
export default frontendNotificationsAPI;


